import React from 'react';

import { Button } from '@opendate-app/setlist';
import CSVImporter from '../../CSVImporter/CSVImporter';
import { toastSuccess } from '../../../shared/toastHelper';

const ImportAttendees = ({
  csrfToken,
  team,
  confirm,
}) => {
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <p style={{"fontSize": "20px", "marginBottom": "3px"}}>
            <strong>Import Attendees</strong>
          </p>
          <p>
            Import attendees from a CSV file
          </p>
        </div>
      </div>
      <hr style={{
        "borderTop": "2px solid var(--od-c-f1f1f1, #f1f1f1)",
        "margin": "30px 0px 25px 0px"
      }} />
      <div className="row">
        <div className="col-12">
          <CSVImporter
            csrfToken={csrfToken}
            team={team}
            importerKey={"b63f2d6f-ac5b-4438-829b-74c48ad76757"}
            type={"CSVImportRows::Attendee"}
            additionalParams={{ confirm_id: confirm.id }}
            onClose={() => { toastSuccess("CSV uploaded successfully."); }}
            renderAnchor={(openModal) => (
              <Button variant="primary" onClick={openModal}>Import Attendees</Button>
            )}
          />
          <p>
            <a href={`/teams/${team.id}/confirms/${confirm.id}/attendees_sample_csv`}
               target="_blank"
               rel="noopener noreferrer">
              Download Sample CSV
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ImportAttendees;
